import { getApiInstance } from './api';
import type { StrengthObjectiveTemplate } from '../pages/atp/strengthObjectives';

export interface StrengthPlanSettings {
  scope: 'week' | 'phase'; week_start?: string; phase_key?: string;
  goal: StrengthObjectiveTemplate; experience: 'new' | 'trained';
  equipment: 'bodyweight' | 'gym'; days: number[]; from_date: string;
}
export interface StrengthPlanSession {
  date: string; goal: StrengthObjectiveTemplate; reason: 'regular' | 'adaptation' | 'race' | 'recovery';
  sets: number; reps_min: number; reps_max: number; rpe: string; rest_seconds: number;
  exercises: Array<{ key: string; sets: number; reps_min: number; reps_max: number; rpe: string; rest_seconds: number }>; duration_seconds: number; existing_id: number | null;
}
export interface StrengthPlanPreview {
  sessions: StrengthPlanSession[]; skipped: Array<{ date: string; reason: string }>;
  signature: string; created_ids: number[];
}
export const strengthPlanApi = {
  async preview(atpId: number, settings: StrengthPlanSettings): Promise<StrengthPlanPreview> {
    const response = await getApiInstance().post('/api/v1/mobile/atp/'+atpId+'/strength-plan', { ...settings, mode: 'preview' });
    return response.data.data;
  },
  async apply(atpId: number, settings: StrengthPlanSettings, preview: StrengthPlanPreview,
    copy: Array<{ date: string; title: string; description: string }>): Promise<StrengthPlanPreview> {
    const response = await getApiInstance().post('/api/v1/mobile/atp/'+atpId+'/strength-plan',
      { ...settings, mode: 'apply', signature: preview.signature, session_copy: copy });
    return response.data.data;
  },
};
